import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/AppStore';
import {
  addCrossSellDisplayed,
  getCrossSellDisplayed,
  saveCrossSellingReferenceSagaRequest,
} from 'domains/crossSelling/CrossSelling.store';
import { CrossSellingContextType } from 'domains/crossSelling/CrossSelling.types';
import { getPrice, getStockInfo } from 'domains/references';
import { getTokenUser } from 'domains/user';
import { hasData } from 'utils';

export const useCrossSellReferenceDisplayed = (
  mainReferenceNumber: string,
  crossSellReferenceNumber: string,
  contextType: CrossSellingContextType,
) => {
  const dispatch = useDispatch();
  const tokenUser = useSelector(getTokenUser);
  const crossSellDisplayed = useSelector((state: RootState) => getCrossSellDisplayed(state, tokenUser?.id ?? ''));
  const price = useSelector((state: RootState) => getPrice(state, crossSellReferenceNumber));
  const stock = useSelector((state: RootState) => getStockInfo(state, crossSellReferenceNumber));

  useEffect(() => {
    if (
      tokenUser &&
      !crossSellDisplayed?.has(`${crossSellReferenceNumber}::${contextType}`) &&
      hasData(price) &&
      hasData(stock?.searchStatus)
    ) {
      dispatch(addCrossSellDisplayed({ userId: tokenUser.id, crossSellRef: crossSellReferenceNumber, contextType }));
      dispatch(
        saveCrossSellingReferenceSagaRequest({
          mainReferenceNumber,
          crossSellReferenceNumber,
          contextType,
          actionType: 'DISPLAY',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [price, stock, contextType]);
};
